import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import {
  formatInt,
  formatMinutes,
  formatPercent,
  formatUsd,
  ratio,
} from "@/lib/statsFormat";
import type { CallStatsAssistantRow } from "@/services/callStatsService";

const TOP_N = 10;

interface AssistantTableProps {
  rows: CallStatsAssistantRow[];
}

const AssistantTable = ({ rows }: AssistantTableProps) => {
  const [showAll, setShowAll] = useState(false);
  const visible = showAll ? rows : rows.slice(0, TOP_N);

  return (
    <Card>
      <CardHeader>
        <CardTitle>Assistants</CardTitle>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Assistant</TableHead>
              <TableHead className="text-right">Calls</TableHead>
              <TableHead className="text-right">Connect rate</TableHead>
              <TableHead className="text-right">Minutes</TableHead>
              <TableHead className="text-right">Cost</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {visible.map((row, index) => (
              <TableRow key={row.assistant_id ?? `unknown-${index}`}>
                <TableCell>{row.name || "Unknown assistant"}</TableCell>
                <TableCell className="text-right">{formatInt(row.calls)}</TableCell>
                <TableCell className="text-right">
                  {formatPercent(ratio(row.connected, row.calls))}
                </TableCell>
                <TableCell className="text-right">{formatMinutes(row.seconds)}</TableCell>
                <TableCell className="text-right">{formatUsd(row.cost_total)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {rows.length > TOP_N && (
          <Button
            variant="ghost"
            size="sm"
            className="mt-2"
            onClick={() => setShowAll((value) => !value)}
          >
            {showAll ? "Show top 10" : `Show all (${rows.length})`}
          </Button>
        )}
      </CardContent>
    </Card>
  );
};

export default AssistantTable;
